import React, { useEffect, useState } from "react";
import { healthcheck } from "../../../../services/Auth/user.service";
import { WEB_AUTH_URL } from "../../../../configurations/paths.config";

function AuthVerify(props) {
    const [fired, setFired] = useState(false);

    const validateHealth = async (userName) => {
        try {
            const serviceResponse = await healthcheck(userName);
            const response = serviceResponse.data;
            if (response.succeeded) {
                setFired(true)
            }
            else {
                //window.location.href = `${WEB_AUTH_URL}/login`
            }
        } catch (error) {
            //window.location.href = `${WEB_AUTH_URL}/login`
        }
    }

    useEffect(() => {
        if ((!props.currentToken || !props.currentToken.token) && window.location.href.indexOf("/login") === -1) {
            //window.location.href = `${WEB_AUTH_URL}/login`
        }
        
        if (fired === false) {
            //validateHealth(props.currentToken.token.userName);
        }
    }, [fired])

    return (<></>);
}

export default AuthVerify;


